// Copyright (c) Qualcomm Technologies, Inc. and/or its subsidiaries.
// SPDX-License-Identifier: BSD-3-Clause-Clear

export const badgeClasses = {
  icon: "qui-badge__icon",
  root: "qui-badge__root",
} as const
